import { FC, memo } from 'react';
import { Body1, Body2, Body3, Box, TextProps } from '@csp/csp-web-ui';
import { BioSampleCode, BioSampleDisplayContainerNumber, BioSampleKitCode } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';

type Props = {
  sampleCode: Maybe<BioSampleCode>;
  kitCode: Maybe<BioSampleKitCode>;
  containerNumber: Maybe<BioSampleDisplayContainerNumber>;
  bold?: boolean;
  hideSampleCodeSubLabel?: boolean;
  large?: boolean;
};

const style: TextProps = {
  component: 'span',
  letterSpacing: '0.1rem',
};

export const BioSampleCodeComponent: FC<Props> = memo(
  ({ bold, sampleCode, kitCode = '', containerNumber = '', hideSampleCodeSubLabel, large }) => {
    const showSampleCodeAsSubLabel = !hideSampleCodeSubLabel && kitCode + containerNumber !== sampleCode;

    const Body = large ? Body1 : Body2;

    return (
      <Box display="flex" flexDirection="column">
        <Box>
          {(kitCode || sampleCode) && (
            <Body mr={1} {...style} fontWeight={bold ? 500 : undefined}>
              {kitCode || sampleCode}
            </Body>
          )}
          {containerNumber && (
            <Body {...style} fontWeight={500}>
              {containerNumber}
            </Body>
          )}
        </Box>
        {showSampleCodeAsSubLabel && (
          <Body3 color="textSecondary" {...style}>
            {sampleCode}
          </Body3>
        )}
      </Box>
    );
  },
);

BioSampleCodeComponent.displayName = 'BioSampleCodeComponent';
